define(function(require, exports, module) {
    'use strict';

    const _ = require('underscore');
    const $ = require('j');
    const core = require('core');
    const config = require('config');
    const MenuView = require('modules/menu/menu.view');
    const scrollManager = require('managers/scroll.manager');
    const urlUtil = require('util/url.util');
    const user = require('user');
    const device = require('util/device.util');
    const language = require('util/language.util');
    const quickDepositService = require('modules/cashier/quick-deposit/quick-deposit.service.instance');

    module.exports = MenuView.extend({

        className: 'lgn-sidebar_menu-wrapper',

        events: _.extend({}, MenuView.prototype.events, {
            'tap .fn-login-btn': 'openLoginPopup',
            'tap .fn-lang-item': 'updateSlideLanguage',
            'tap .info-guest_register ': 'close'
        }),

        initialize: function() {
            this.setUrlToIsMenuHovered();
        },

        render: function() {
            _.invoke(this.childViews, 'close');
            this.isMobile = device.formFactor === 'mobile';

            this.childViews = [];

            this.menuItems = this.model.getFilteredByRoleItems();

            if (!this.isMobile) {
                this._renderNavMenu();
            } else {
                this._renderSideMenu();
            }

            if (!this.slideMenuWcId) {
                this.attachWidget(this.$el.accordion({
                    isCollapseSiblings: false,
                    headerExpandedClass: 'fn-accordion-header_expanded slide-menu__list__header_expanded',
                    bodyExpandedClass: 'fn-accordion-body_expanded slide-menu__list__body_expanded'
                }));
            }

            this.activateMenu(this.backgroundPage || urlUtil.getCleanUrl(urlUtil.pathname));

            return this;
        },

        subscribe: function() {
            this.listenTo(core, {
                'page:clear page:refresh navigate': this.close,
                'page:rendered page:shown': this.handleNavigate,
                'popup:rendered': _.compose(this.close, this.hideSubMenu),
                'auth:login auth:logout page:refresh': this.render,
                'menu:action:open': this.open,
                'menu:action:close': this.close,
                'user:action:changeLanguage': this.close,
                'inbox:open': this.close,
                'chat:open': this.close,
            });

            this.listenTo(quickDepositService, {
                'change:isQuickDepositAvailable': this.render
            });

            if (!this.isDesktopMenu()) {
                $.event.add(window, 'orientationchange', function() {
                    if (this.opened) {
                        if (device.browserName === 'androidNative' && device.alias === 'Lenovo_A850') {
                            this.redraw(this.el, 1200);
                            this.redraw($('.fn-overlay'), 500);
                        } else if (device.os === 'android') { // trigger redraw event for setting right height
                            this.redraw(this.el, 500);
                        }

                        // redraw list item for correct scrolling in ios
                        if (device.name === 'ipad' && device.osVersion === '8.1.1') {
                            return;
                        }

                        this.redraw(this.$('.fn-menu-list'));

                    }
                }.bind(this));
            }
        },

        updateSlideLanguage: function(event) {
            Playtech.API.language.setCurrentLanguage(event.target.dataset?.lang);
            this.close();
        },

        getRegistrationURL: function() {
            const lang = Playtech.API.language.getCurrentLanguage();
            var registrationUrlDefault = config.get('registrationURL');
            var dynamicTags = config.get('dynamicTags') || {};
            const refistrationDynamicTagName = `DTAG_LINK_REGISTRATION_${lang?.split('_')[0].toUpperCase()}`;

            return dynamicTags[refistrationDynamicTagName] || registrationUrlDefault || '/';
        },

        /**
         * Open login popup
         * @param  {Event} e
         */
        openLoginPopup: function(e) {
            e.preventDefault();

            Playtech.API.auth.showLogin({
                afterLoginUrl: encodeURIComponent(window.location.pathname)
            });
        },

        /**
         * Show menu on page
         */
        open: function() {
            if (this.isMobile) {
                if (this.wrap) {
                    this.wrap.scrollTop = 0;
                }

                // prevent body scrolling while menu is open
                scrollManager.disableScrolling(this);

                // hack: ios > 9 fix menu appearing shifted below bottom if opened from lowest scroll position
                if (device.os === 'ios' && parseInt(device.osVersion) >= 9) {
                    this.redraw(this.el);
                }
                $('.fn-open-menu').addClass('isOpened');
                // hack: adding setTimeout fixes animation on open when `this.redraw()` is called
                window.setTimeout(function() {
                    this.$el.addClass('open');
                    this.renderOverlay();
                    $('.fn-page').addClass('page_state_menu-open');
                    this.opened = true;
                }.bind(this), 0);
            }
        },

        /**
         * Hide menu from page
         */
        close: function(callback) {
            if (this.isMobile) {
                if (document.querySelector('.toggle_checkbox')) {
                    document.querySelector('.toggle_checkbox').checked = false;
                }

                scrollManager.enableScrolling(this);
                $(window).off('.menu');

                this.$el.addClass('close');

                this.transitionEnd(this.$('.fn-slide-menu-wrapper'), function() {
                    this.$el.removeClass('open close');
                    if (_.isFunction(callback)) {
                        callback();
                    }
                }, this);

                $('.fn-open-menu').removeClass('isOpened');

                this.removeOverlay();

                $('.fn-page').removeClass('page_state_menu-open');
                this.opened = false;
            }
        },

        setUrlToIsMenuHovered() {
            const menuItems = config.get('menuItems') || window.Playtech.Variables.menuItems || [];
            this.urlToIsMenuHovered = [].reduce.call(menuItems, function(result, current) {
                result[current.url] = current.isHoverMenu;
                return result;
            }, {});
        },

        _renderNavMenu: function() {
            this.setUrlToIsMenuHovered();
            this.$el.html(this.tmpl('nav.menu', {
                menuItems: this.menuItems,
                urlToIsMenuHovered: this.urlToIsMenuHovered
            }).replace());
        },

        _renderSideMenu: function() {
            if (this.slideMenuWcId) {
                this.$el.find('.fn-common-slide-menu').remove();

                return;
            }

            var themeName = config.get('themeName');
            var customizationURLs = config.get('customization') || {};
            var requestStamp = config.get('requestStamp');
            var currentLanguage = Playtech.API.language.getCurrentLanguage();
            var hideChatByUrl = urlUtil.getLocationParameterByName('hideChat') === '1';
            var logoURL = customizationURLs.siteLogoPath ? customizationURLs.siteLogoPath + '?t=' + requestStamp : '/' + themeName + '/images/logo.png?t=' + this.model.get('t');
            var twoLetterLanguage = Playtech.API.language.getTwoLetterCurrentLanguage();

            var options = _.extend(this.model.toJSON(), {
                menuItems: this.menuItems,
                isUserLogged: user.isLoggedIn(),
                logoURL: logoURL,
                registerURL: this.getRegistrationURL(),
                showChatIcon: config.get('chatWidget')
                    && config.get('chatWidget').showIcon && config.get('chatWidget').enabled && !hideChatByUrl,
                currentLanguage: currentLanguage,
                twoLetterLanguage: twoLetterLanguage,
                allowedLocales: language.allowedLocales.filter(locale => locale !== currentLanguage)
            });

            this.$el.html(this.tmpl('side.menu', options).replace());

            this.wrap = this.$('.fn-menu-wrap')[0];
            this.list = this.$('.fn-menu-list')[0];
        },

        activateMenu: function(pageUrl) {
            const rootPage = urlUtil.getCleanUrl(config.get('rootPage'));
            const rootPageUrl = pageUrl === rootPage ? '/' : pageUrl;

            if (this.isDesktopMenu()) {
                this.toggleSecondlevelMenu(rootPageUrl);
            }

            this.setActiveMenu(rootPageUrl);
        },

        /**
         * Add active class for menu item
         */
        setActiveMenu: function(pageUrl) {
            this.$('.active').removeClass('active');

            const twoLetterLanguage = Playtech.API.language.getTwoLetterCurrentLanguage();
            const isRootPageUrl = pageUrl === `/${twoLetterLanguage}/`; /* Lugano changes */

            const currentParentItems = this.model.getCurrentParentItems(pageUrl);
            const currentItem = this.model.getCurrentItem(pageUrl, !isRootPageUrl); /* Lugano changes */
            const currentParentItem = this.model.getCurrentParentItem(pageUrl);

            [...currentParentItems, currentItem, currentParentItem].forEach(function(item) {
                if (!item) {
                    return;
                }
                var $link = this.$('[data-url="' + item.friendlyURL + '"]');
                !$link.hasClass('fn-accordion') && $link.addClass('active');
            }, this);
        },

        handleLinkNavigate: function(e) {
            e.preventDefault();

            var path = e.currentTarget.getAttribute('href') || e.currentTarget.dataset.url;
            var target = e.currentTarget.getAttribute('target');

            // Check if the current pathname matches the link's path
            // If they match, prevent navigation to avoid unnecessary navigate
            if (window.location.pathname === path) {
                return;
            }

            return core.navigate(path, { target });
        }
    });
});
